const IMMUTABLE_PAYMENT_TERMS = ['Vorauszahlung', 'NN'];

function isPaymentTermsMutable(
    defaultPaymentTermId: string | undefined,
    isInPreorderMode: boolean
) {
    return !!(
        defaultPaymentTermId &&
        (isInPreorderMode ||
            !IMMUTABLE_PAYMENT_TERMS.includes(defaultPaymentTermId))
    );
}

export default isPaymentTermsMutable;
